import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Layout from '../components/Layout';
import Seo from '../components/Seo';
import PageHero from '../components/PageHero';
import { poemsApi, martyrsApi } from '../services/api';

const PoemsPage = () => {
  const [params] = useSearchParams();
  const martyrId = params.get('id');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [martyrName, setMartyrName] = useState('');

  useEffect(() => {
    if (!martyrId) {
      setMartyrName('');
      return;
    }
    martyrsApi.getById(martyrId)
      .then((data) => setMartyrName(data.martyr?.name_ar || ''))
      .catch(() => setMartyrName(''));
  }, [martyrId]);

  useEffect(() => {
    const timer = setTimeout(async () => {
      try {
        setLoading(true);
        const data = await poemsApi.getAll({
          limit: 24,
          ...(search && { search }),
          ...(martyrId && { martyr_id: martyrId })
        });
        setItems(data.poems || []);
      } finally {
        setLoading(false);
      }
    }, 250);
    return () => clearTimeout(timer);
  }, [search, martyrId]);

  const poets = [...new Set(items.map((item) => item.poet_name).filter(Boolean))];
  const title = martyrId ? `قصائد${martyrName ? ` — ${martyrName}` : ''}` : 'القصائد';
  const subtitle = martyrId
    ? `قصائد الرثاء الخاصة بهذا الشهيد.`
    : 'كل القصائد في الأرشيف: العامة وما كُتب في رثاء شهيد معيّن.';

  return (
    <Layout>
      <Seo title={title} description={subtitle} />
      <PageHero eyebrow={martyrId ? 'عن الشهيد' : 'ديوان الأرشيف'} title={title} subtitle={subtitle} />
      <div className="container-responsive py-12">
        <div className="mb-10 rounded-3xl bg-white p-5 shadow-soft dark:bg-stone-900">
          <input className="form-input" placeholder="ابحث في القصيدة أو اسم الشاعر" value={search} onChange={(e) => setSearch(e.target.value)} />
        </div>
        {poets.length > 0 && (
          <div className="mb-8 flex flex-wrap gap-2">
            {poets.map((poet) => (
              <button key={poet} type="button" className="rounded-full bg-stone-200 px-3 py-1 text-sm dark:bg-stone-800" onClick={() => setSearch(poet)}>
                {poet}
              </button>
            ))}
          </div>
        )}
        {loading ? <p>جاري التحميل...</p> : (
          <div className="grid gap-6 md:grid-cols-2">
            {items.map((item) => (
              <Link key={item.id} to={`/poems/${item.id}`} className="rounded-[2rem] border border-gold-500/20 bg-white p-8 text-center shadow-soft transition hover:-translate-y-1 dark:bg-stone-900">
                <h2 className="text-2xl font-bold">{item.title}</h2>
                {item.poet_name && (
                  <p className="poet-name mt-2 text-xl text-gold-700">الشاعر: {item.poet_name}</p>
                )}
                {item.martyr_name_ar && <p className="mt-2 text-sm text-stone-500">عن الشهيد {item.martyr_name_ar}</p>}
                <p className="poem-verse mt-6 line-clamp-5">{item.content}</p>
              </Link>
            ))}
          </div>
        )}
        {!loading && items.length === 0 && <p className="py-16 text-center text-stone-500">لا توجد قصائد مطابقة</p>}
      </div>
    </Layout>
  );
};

export default PoemsPage;
